module.exports = __webpack_public_path__ + "images/market/introduction/1_0cd7ab053b4484e5d50596863b4947a6.png";